module.exports = __webpack_public_path__ + "images/436f47539bcccedafa2d6bd6b7108d80bolt.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bolt.png
// module id = CO3H
// module chunks = 0